import { styled } from 'styled-components';
import layoutStyle from '../../../../../components/styles/Layout';

export const RowsLayout = styled.div`
  ${layoutStyle}
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
